const __filename = "/app/views/layouts/cms.js", __dirname = "/app/views/layouts";
if (document.body.dataset.helpScout === 'enabled') {
  import('/lib/helpscout')
}
